import axios from "@/axios"

const url = "/api/general/chicks-by-cintillos"

class ChickCintillosService {

	async list(params) {
		const { data } = await axios.get(`${url}`, {params})
		return data
	}
}
export default new ChickCintillosService()
